export enum EntityType {
  ProductList = 'productList',
  LookBook = 'lookBook',
}
